import { useState, useEffect, useRef, useContext } from "react"
import { NavBar, BtnLoader } from "../../components";
import { handelUpdateProfileMethod } from '../../methods'
import { ContextAuth } from "../../context";
import { useNavigate } from 'react-router-dom';
import { CSvgCamera } from '../../components/CSvg'

export const Profile = () => {
    const formRef: any = useRef()
    const CtxAuth = useContext(ContextAuth)
    const navigate = useNavigate();
    const [displayBtn, setDisplayBtn] = useState<boolean>(false)
    const [imageFile, setImageFile] = useState<any>(null)
    const [user, setUser] = useState<any>(null)

    const handelUpdateProfile = (e: any) => {
        e.preventDefault()
        handelUpdateProfileMethod(formRef, imageFile, setDisplayBtn, CtxAuth.setUserInfo, navigate)
    }

    const selectImage = (e: any) => {
        let image = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = function () {
            setImageFile(reader.result)
        }
        reader.readAsDataURL(image);
    }

    useEffect(() => {
        document.title = " ویرایش پروفایل | دایان"
        if (CtxAuth?.userInfo != null) {
            formRef.current['name'].value = CtxAuth?.userInfo.fname;
            formRef.current['family'].value = CtxAuth?.userInfo.lname;
            formRef.current['year'].value = CtxAuth?.userInfo.birthday.slice(0, 4);
            formRef.current['month'].value = CtxAuth?.userInfo.birthday.slice(5, 7);
            formRef.current['day'].value = CtxAuth?.userInfo.birthday.slice(8, 10);
        }
    }, [CtxAuth?.userInfo])

    return (
        <>
            <div className='w-full min-h-screen flex flex-col'>
                <NavBar title='ویرایش پروفایل' />
                <div className='w-full flex flex-col p-[20px]'>
                    <form onSubmit={handelUpdateProfile} ref={formRef} className='w-full max-w-[350px] m-auto mt-[100px]  rounded-lg border shadow flex flex-col justify-center items-center overflow-hidden py-[30px] px-[10px]'>
                        <label className='relative'>
                            <input onChange={(e: any) => selectImage(e)} type='file' className='invisible opacity-0 hidden' />
                            <div className='w-[100px] h-[100px] shadow rounded-full flex items-center justify-center cursor-pointer'>
                                <div className='w-[90px] h-[90px] flex items-center justify-center border border-gray-400 border-dashed rounded-full'>
                                    {imageFile == null ?
                                        <img src={CtxAuth?.userInfo?.avatar} alt='profile' className='w-full h-full object-cover object-center rounded-full' />
                                        :
                                        <>
                                            {imageFile == 'delete' ?
                                                <CSvgCamera className='w-[40px] fill-gray-400' />
                                                :
                                                <img src={imageFile} alt='profile' className='w-full h-full object-cover object-center rounded-full' />
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                            <div onClick={() => { setImageFile('delete') }} className='w-[20px] h-[20px] absolute rounded-full bg-red-600 text-white text-sm flex items-center justify-center top-0 cursor-pointer'>x</div>
                        </label>
                        <div className=" w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-3">نام </span>
                            <input name='name' className='w-full h-[40px] border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} />
                        </div>
                        <div className=" w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-3">نام خانوادگی</span>
                            <input name='family' className='w-full h-[40px] border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} />
                        </div>
                        <div className=" w-full flex flex-col mt-4">
                            <span className="text-xs text-gray-500 mb-3">تاریخ تولد</span>
                            <div className='w-full flex items-center'>
                                <div className='w-full pl-1'>
                                    <select name='day' className='w-full h-[40px]  bg-transparent border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} >
                                        <option value="" disabled selected>روز</option>
                                        {days.map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </select>
                                </div>
                                <div className='w-full px-1'>
                                    <select name='month' className='w-full h-[40px]  bg-transparent border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} >
                                        <option value="" disabled selected>ماه</option>
                                        {month.map((item: any, index: number) =>
                                            <option key={index} value={item}>{item}</option>
                                        )}
                                    </select>
                                </div>
                                <div className='w-full pr-1'>
                                    <select name='year' className='w-full h-[40px]  bg-transparent border border-gray-400 rounded-md px-2 text-sm  focus:outline-none' required={true} >
                                        <option value="" disabled selected>سال</option>
                                        {new Array(71).fill('').map((item: any, index: number) =>
                                            <option key={index} value={+index + 1330}>{+index + 1330}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {displayBtn ?
                            <button type={'button'} className='w-full h-[40px] bg-dayan-orange-50 rounded-md text-white mt-6 flex items-center justify-center relative cursor-not-allowed'><BtnLoader /></button>
                            :
                            <button type={'submit'} className='w-full h-[40px] bg-dayan-orange-50 rounded-md text-white mt-6'>ثبت</button>
                        }
                    </form>
                </div>
            </div>

        </>
    );
}



let days = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
]



let month = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
]



let year = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
]